module.exports = require("babel-runtime/helpers/taggedTemplateLiteral");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/taggedTemplateLiteral"
// module id = 4
// module chunks = 0